@if (data$ | async; as data) {
  <div class="mt-1">
    <app-alerts />
  </div>

  <app-admin-refund-settings-form
    [data]="data"
    (submitClickEvent)="handleSubmitClick($event)" />
} @else {
  <app-spinner-filled />
}
